import { useState } from "react";
import { Calendar as CalendarIcon, X } from "lucide-react";
import { format, parse, isValid } from "date-fns";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export function DatePickerInput({ value, onChange, placeholder = "Pick a date", testId }) {
  const [open, setOpen] = useState(false);

  const dateObj = value ? (() => {
    const d = new Date(value + "T00:00:00");
    return isValid(d) ? d : undefined;
  })() : undefined;

  const handleSelect = (day) => {
    if (day) {
      onChange(format(day, "yyyy-MM-dd"));
    }
    setOpen(false);
  };

  const clear = (e) => {
    e.stopPropagation();
    onChange("");
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          data-testid={testId}
          className="flex items-center gap-2 bg-white rounded-xl border border-[#E5E5EA] px-3 py-2 text-xs w-[140px] hover:border-[#00A3E0] transition-colors"
          style={{ backgroundColor: 'var(--bg-input)', borderColor: 'var(--border-main)', color: value ? 'var(--text-primary)' : 'var(--text-muted)' }}
        >
          <CalendarIcon className="w-3.5 h-3.5 flex-shrink-0" style={{ color: 'var(--text-muted)' }} />
          <span className="flex-1 text-left truncate">
            {dateObj ? format(dateObj, "dd MMM yyyy") : placeholder}
          </span>
          {value && (
            <X className="w-3 h-3 flex-shrink-0 hover:text-red-500 transition-colors" style={{ color: 'var(--text-muted)' }} onClick={clear} />
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 rounded-2xl" align="start" style={{ backgroundColor: 'var(--bg-card)', border: '1px solid var(--border-main)' }}>
        <Calendar
          mode="single"
          selected={dateObj}
          onSelect={handleSelect}
          initialFocus
          className="rounded-2xl"
        />
      </PopoverContent>
    </Popover>
  );
}
